import { Injectable } from "@angular/core";
import { domain } from "../variables/domain";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";
import { EncryptionService } from "./encryption.service";
import { SharedServices } from "./shared.service";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  constructor(
    private http: HttpClient,
    private encryptionService: EncryptionService,
    private sharedServices: SharedServices
  ) {}

  PostShortList(details) {
    return this.http
      .post(domain.addProperties + "shortListProperty", details)
      .pipe(map((res: any) => res));
  }
  GetPropertyShortList(userId,skip, take) {
    return this.http
      .get(
        domain.addProperties +
          "GetMyShortlistProperties?skip=" +
          skip +
          "&take=" +
          take + "&userId=" + userId
      )
      .pipe(map((res: any) => res));
  }
  getImages(PropID) {
    return this.http
      .get(
        environment.apiBaseUrl +
          "Property/getPropertyImage?propertyId=" +
          PropID
      )
      .pipe(map((res: any) => res));
  }
  GetPropertyById(PropID) {
    return this.http
      .get(
        environment.apiBaseUrl + "Property/GetPropertyById?PropertyId=" + PropID
      )
      .pipe(map((res: any) => res));
  }
  SaveInvitation(details) {
    return this.http
      .post(environment.apiBaseUrl + "Invitation/SaveInvitation", details)
      .pipe(map((res: any) => res));
  }
  GetAllInvitations() {
    return this.http
      .get(environment.apiBaseUrl + "Invitation/GetAllInvitations")
      .pipe(map((res: any) => res));
  }
  GetBulderAllInvitations() {
    return this.http
      .get(environment.apiBaseUrl + "Invitation/GetInvitations")
      .pipe(map((res: any) => res));
  }
  SaveInvitationResponse(InvitationId, respType) {
    return this.http
      .post(
        environment.apiBaseUrl +
          "Invitation/ReplyToInvitation?InvitationId=" +
          InvitationId +
          "&respType=" +
          respType,
        {}
      )
      .pipe(map((res: any) => res));
  }
  DeleteShortList(ID) {
    return this.http
      .post(
        environment.apiBaseUrl +
          "Property/RemoveShortListProperty?ShortListId=" +
          ID,
        {}
      )
      .pipe(map((res: any) => res));
  }
  DeleteInvitations(ID) {
    return this.http
      .post(
        environment.apiBaseUrl +
          "Invitation/RemoveInvitation?InvitationId=" +
          parseInt(ID),
        {}
      )
      .pipe(map((res: any) => res));
  }
  DeleteMyPost(ID) {
    return this.http
      .post(
        environment.apiBaseUrl +
          "Property/RemoveProperty?PropertyMastId=" +
          parseInt(ID),
        {}
      )
      .pipe(map((res: any) => res));
  }
  UpdatePropertyActiveStatus(PropertyMastId, status) {
    return this.http
      .post(
        environment.apiBaseUrl +
          "Property/UpdatePropertyActiveStatus?PropertyMastId=" +
          PropertyMastId +
          "&status=" +
          status,
        {}
      )
      .pipe(map((res: any) => res));
  }
  RepostMyProperties(PropertyMastId) {
    return this.http
      .post(
        environment.apiBaseUrl +
          "Property/RepostProperty?PropertyMastId=" +
          PropertyMastId,
        {}
      )
      .pipe(map((res: any) => res));
  }
  GetUserDetails(id) {
    return this.http
      .get(domain.URL + "GetUserDetailsById?UserId=" + id)
      .pipe(map((res: any) => res));
  }
  createPropertyActivity(details) {
    return this.http
      .post(environment.apiBaseUrl + "PropertyActivity/SaveActivity", details)
      .pipe(map((res: any) => res));
  }
  updatePropertyActivity(details) {
    return this.http
      .post(environment.apiBaseUrl + "PropertyActivity/UpdateActivity", details)
      .pipe(map((res: any) => res));
  }
  GetActivityByProperty(leadId) {
    return this.http
      .get(
        environment.apiBaseUrl +
          "PropertyActivity/GetActivityByProperty?propertyId=" +
          leadId
      )
      .pipe(map((res: any) => res));
  }
  getActivityStatusCount(agentuserid, roleTypeId) {
    return this.http
      .get(
        environment.apiBaseUrl +
          "PropertyActivity/GetActivitiesCount?UserId=" +
          parseInt(this.sharedServices.getAgentId()) +
          "&AgentUserId=" +
          agentuserid +
          "&RoleTypeId=" +
          roleTypeId
      )
      .pipe(map((res: any) => res));
  }
  GetPropertywiseActivityData(status,agentuserid,roleTypeId) {
    return this.http
      .get(
        environment.apiBaseUrl +
          "PropertyActivity/GetPropertywiseActivityData?query=" +
          status + 
          "&AgentUserId=" +
          agentuserid +
          "&RoleTypeId=" +
          roleTypeId +
          "&UserId=" +
          parseInt(this.sharedServices.getAgentId()) +
          "&skip=0&take=100000000"
      )
      .pipe(map((res: any) => res));
  }
  GetDataByActivities(status,agentuserid,roleTypeId) {
    return this.http
      .get(
        environment.apiBaseUrl +
          "PropertyActivity/GetDataByActivities?query=" +
          status +
          "&AgentUserId=" +
          agentuserid +
          "&RoleTypeId=" +
          roleTypeId +
          "&skip=0&take=100000000"
      )
      .pipe(map((res: any) => res));
  }
  shareProperty(type: string, id: any) {
    return this.http
      .get(
        domain.ShareProperty + type + "&id=" + id,
        { responseType: 'blob', observe: 'response' }
      )
      .pipe(map((res: any) => res));
  }
  SharePropertyToConnectedAgent(propertyId: any, isShare: boolean) {
    return this.http
      .post(
        environment.apiBaseUrl + "Agent/SharePropertyToConnectedAgent",
        {
          PropertyId: propertyId,
          IsShare: isShare ? 1 : 0,
        }
      )
      .pipe(map((res: any) => res));
  }
}
